import type { ReactNode } from 'react';
import './estados.css';
import { Botao } from '@/shared/ui';

/**
 * A faixa: informa SEM substituir o conteúdo.
 *
 * Mora em `shared/ui/estados/` e não em `shared/ui/`, porque é um dos cinco estados — o
 * CSS dela já está em `estados.css`. Mover para `shared/ui/` seria churn sem
 * ganho: o que falta não é lugar, é as seis telas que reimplementaram o
 * próprio aviso de erro passarem a usá-la.
 *
 *   defasado    o dado é velho e continua utilizável. Neutro TRACEJADO,
 *               nunca amarelo: se dado velho fosse amarelo, a pessoa
 *               aprenderia a ignorar amarelo, e aí o aviso de verdade sumiria
 *               junto.
 *   bloqueado   a ação NÃO aconteceu, e o motivo vem escrito. Vermelho porque
 *               é agora, e não "vai acontecer depois".
 *   atencao     o pedido não falhou: ele ESPERA resposta, e a consequência de
 *               responder sim não é óbvia. Âmbar, e é o único que é — é para
 *               este caso que o amarelo estava reservado.
 *   ok          o que pedia atenção foi resolvido por uma ação da pessoa, e a
 *               faixa confirma que valeu (#765: "Os 10 GB a mais já valem").
 *               Verde, e aparece em vez de surgir de repente.
 */
export type TomFaixa = 'defasado' | 'bloqueado' | 'atencao' | 'ok';

export type FaixaProps = {
  tom: TomFaixa;
  /** O texto. Em `bloqueado`, é o motivo. */
  children: ReactNode;
  /** Só em `defasado`: a idade em palavras, com o instante exato no title. */
  idade?: { texto: string; exato: string };
  acao?: { rotulo: string; aoClicar: () => void };
  /**
   * O ícone desta faixa, no lugar do de cada tom: a nuvem do armazenamento.
   * Só desenho; o que a faixa diz está no texto.
   */
  icone?: ReactNode;
};

const ICONE_DO_TOM: Readonly<Record<TomFaixa, string>> = {
  defasado: '⏱',
  bloqueado: '⚠',
  atencao: '❓',
  ok: '✓',
};

export function Faixa({ tom, children, idade, acao, icone }: FaixaProps) {
  return (
    <div className={`faixa faixa--${tom}`} role={tom === 'bloqueado' ? 'alert' : 'status'}>
      <span className="faixa__icone" aria-hidden="true">
        {icone ?? ICONE_DO_TOM[tom]}
      </span>
      <span className="faixa__texto">
        {children}
        {idade ? (
          <>
            {' '}
            <time title={idade.exato}>{idade.texto}</time>
          </>
        ) : null}
      </span>
      {acao ? (
        <Botao variante="fantasma" miudo onClick={acao.aoClicar}>
          {acao.rotulo}
        </Botao>
      ) : null}
    </div>
  );
}
